import type { ReactNode } from 'react';
import { CheckCircle2 } from 'lucide-react';

interface Props {
  title: string;
  children?: ReactNode;
}

export default function ThankYou({ title, children }: Props) {
  return (
    <div className="rf-card rf-center">
      <div className="rf-success-icon">
        <CheckCircle2 size={36} strokeWidth={2.2} />
      </div>
      <h2 className="rf-title" style={{ marginBottom: '0.75rem' }}>{title}</h2>
      <div className="rf-muted">{children}</div>
    </div>
  );
}
